const KEY = window.fadoq_address_complete?.api_key;
const BASE_URL = 'https://ws1.postescanada-canadapost.ca';

const $addressInput = document.getElementById('hub-filters-address');

function loadAddressComplete() {
    return new Promise((resolve, reject) => {
        const $style = document.createElement('link');
        $style.rel = 'stylesheet';
        $style.href = `${BASE_URL}/css/addresscomplete-2.50.min.css?key=${KEY}`;
        document.head.appendChild($style);

        const $script = document.createElement('script');
        $script.src = `${BASE_URL}/js/addresscomplete-2.50.min.js?key=${KEY}`;
        $script.async = true;
        $script.onload = resolve;
        $script.onerror = reject;
        document.head.appendChild($script);
    });
}

function initAddressComplete() {
    const { pca } = window;
    if (!pca?.Address) return;

    const control = new pca.Address(
        [{ element: $addressInput.id, field: '', mode: pca.fieldMode.SEARCH }],
        { key: KEY, culture: document.documentElement.lang || 'fr-CA' },
    );

    control.listen('populate', (address) => {
        $addressInput.value = [address.Line1, address.City, `${address.ProvinceCode} ${address.PostalCode}`]
            .filter((part) => part && part.trim())
            .join(', ');

        $addressInput.form?.requestSubmit();
    });
}

if ($addressInput && KEY) {
    $addressInput.addEventListener('focus', () => {
        loadAddressComplete()
            .then(initAddressComplete)
            .catch(() => {});
    }, { once: true });
}
